import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@viso/core/data-access';
import { Environment, Response } from '@viso/core/models';
import { catchError, map } from 'rxjs/operators';
import { VendorService } from '@viso/web/vendor/shared/models';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VendorServiceService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {}

  getVendorService(id: string) {
    return this.http
      .get<Response<VendorService>>(
        `${this.environment.API_URL}/vendor/service/${id}`
      )
      .pipe(map((response) => response.body));
  }

  getAllVendorService() {
    return this.http
      .get<Response<VendorService[]>>(
        `${this.environment.API_URL}/vendor/service`
      )
      .pipe(map((response) => response.body));
  }

  addVendorService(vendor: VendorService) {
    return this.http
      .post<Response<VendorService>>(
        `${this.environment.API_URL}/vendor/service`,
        vendor
      ).pipe(
        catchError(({error}) => {
          return throwError(error)
        })
      );
  }

  updateVendorService(id, vendor: VendorService) {
    return this.http
      .put<Response<VendorService>>(
        `${this.environment.API_URL}/vendor/service/${id}`,
        vendor
      );
  }

  deleteVendorService(id) {
    return this.http.delete<Response<VendorService>>(
      `${this.environment.API_URL}/vendor/service/${id}`
    );
  }

  getEligibleServices(id) {
    return this.http.get<Response<VendorService[]>>(
      `${this.environment.API_URL}/vendor/eligible-services/${id}`
    );
  }
}
